import React from 'react';

import { scaleBand, scaleLinear, scalePoint, tickFormat, max} from 'd3';

import { Dots } from './Dots';
import { Bars } from './Bars';
import { BarAxisLeft } from './BarAxisLeft';
import { CatAxisBottom } from './CatAxisBottom';
import { CatAxisLeft } from './CatAxisLeft';
import { BorderlessGraph } from '../generalPlot/BorderlessGraph';
import { Border } from '../generalPlot/Border';


const margin = {top: 50, left: 70, bottom: 50, right: 20, innerPad: 20};


export const DetailPlot = ( {data, width, height, title, color} ) => {
  if (!data) {
    return null
  }
  const availableFattyAcids = data.map(d => (d.fatty_acids.map(fa => fa.label))).flat();
  const uniqueFattyAcids = [... new Set(availableFattyAcids)]
  const fattyAcids = uniqueFattyAcids.sort().reverse();
  const molecularSpecies = data.map(d => d.label);

  const plotHeight = height - margin.top - margin.bottom
  const innerHeight = (plotHeight - margin.innerPad ) / 2;
  const innerWidth = width - margin.left - margin.right;

  const x = scaleBand()
    .domain(molecularSpecies)
    .range([0, innerWidth])
    .padding(0.1);
  
  const y = scaleLinear()
    .domain([0, max(data, d => (d.probability))+0.01])
    .range([innerHeight, 0])
    .nice();
  
  const yFa = scalePoint()
    .domain(fattyAcids)
    .range([innerHeight, 0]);

  const formatter = tickFormat(0, 1, 5, "%");
  return (
    <>
    <BorderlessGraph
      width={width}
      height={height}
      margin={margin}
    >
      <text
        className="plot-title"
        x={innerWidth / 2} y={-15} textAnchor="middle">{title}</text>
      <BarAxisLeft
        y={y}
        innerWidth={innerWidth}
        formatter={formatter}
      />
      <Border width={innerWidth} height={innerHeight} />
      <Bars
        data={data}
        x={x}
        y={y}
        color={null}
        innerHeight={innerHeight}
      />
      <text 
        className="axis-label"
        transform={`translate(-55,${innerHeight/2}) rotate(-90)`}
        textAnchor="middle">Probability / %</text>
      <g transform={`translate(0, ${innerHeight + margin.innerPad })`}>
      <CatAxisBottom
        x={x}
        innerHeight={innerHeight}
      />
      <CatAxisLeft
        y={yFa}
        innerWidth={innerWidth}
        formatter={formatter}
      />
      <Border width={innerWidth} height={innerHeight} />
      <Dots
        data={data}
        x={x}
        y={yFa}
        innerHeight={innerHeight}
        color={color}
      />
      </g>
    </BorderlessGraph>
    </>
  );
};